const AccordionIcon = ({ open }) => open ? <span className="material-symbols-outlined search-i">expand_more</span> : <span className="material-symbols-outlined search-i">chevron_right</span>

export default AccordionIcon